import React, { useEffect, useState } from 'react'
import PageHeader from 'components/atoms/PageHeader'
import ContentPanel from 'components/atoms/ContentPanel'
import ProductsTable from 'modules/products/components/ProductsTable'
import SearchInput from 'components/atoms/SearchInput'
import styled from 'styled-components'
import { changeQuery, getCurrentParsedQuery, isAuthorized } from 'utils/navigation'
import { dissoc, propOr } from 'ramda'
import FiltersButton from 'components/atoms/FiltersButton'
import ProductsFilters from 'modules/products/components/ProductsFilters'
import { isNilOrEmpty, isNotNilOrEmpty } from 'utils/ramda'
import ImportProductsFromSGTModal from 'modules/products/components/ImportProductsFromSGTModal'
import ImportProductsFromIAIModal from '../modules/products/components/ImportProductsFromIAIModal'
import { FiltersWrapper, HeaderWrapper } from 'theme/wrappers'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from 'modules/auth/ducks/selectors'
import AddProductModal from 'modules/products/components/AddProductModal'

const Products = () => {
  const [filtersOpen, setFiltersOpen] = useState(false)
  const currentUser = useSelector(selectCurrentUser)
  const userRoles = propOr([], 'roles', currentUser)
  const priviledgedRoles = ['admin', 'foreman', 'bok']
  const priviledgedRolesSGT = ['admin', 'bok']
  const priviledgedRolesAddProduct = []

  useEffect(() => {
    const query = getCurrentParsedQuery()
    const filters = dissoc('search', propOr({}, 'filter', query))
    setFiltersOpen(isNotNilOrEmpty(filters))
  }, [])

  const toggleFilters = () => setFiltersOpen(prev => !prev)

  const handleSubmit = searchQuery => {
    const parsedQuery = {
      ...getCurrentParsedQuery(),
        allow_subproducts: 1
    }
    const isEmpty = isNilOrEmpty(searchQuery)

    changeQuery({
      ...parsedQuery,
      page: 1,
      filter: isEmpty
        ? dissoc('search', propOr({}, 'filter', parsedQuery))
        : {
            ...propOr({}, 'filter', parsedQuery),
            search: searchQuery
          }
    })
  }

  const handleClear = () => {
    const parsedQuery = getCurrentParsedQuery()
    changeQuery({
      ...parsedQuery,
      filter: dissoc('search', propOr({}, 'filter', parsedQuery))
    })
  }

  return (
    <>
      <HeaderWrapper>
        <PageHeader>Lista produktów</PageHeader>
        <FiltersWrapper>
          {isAuthorized(priviledgedRolesSGT, userRoles) ? <ImportProductsFromSGTModal /> : null}
          {isAuthorized(priviledgedRoles, userRoles) ? <ImportProductsFromIAIModal /> : null}
          {isAuthorized(priviledgedRolesAddProduct, userRoles) ? <AddProductModal /> : null}
          <FiltersButton active={filtersOpen} onClick={toggleFilters} />
          <InputWrapper>
            <SearchInput
              onSubmit={handleSubmit}
              onClear={handleClear}
              placeholder='Znajdź produkt...'
            />
          </InputWrapper>
        </FiltersWrapper>
      </HeaderWrapper>
      <ProductsFilters open={filtersOpen} />
      <ContentPanel>
        <ProductsTable />
      </ContentPanel>
    </>
  )
}

export default Products

const InputWrapper = styled.div`
  max-width: 250px;
`
